export const useTrustedWidgetShops = async () => {
  const router = useRouter()
  try {
    const widget = await checkElement('#minimized-trustbadge-98e3dadd90eb493088abdc5597a70810')
    if (widget?.querySelector('.trustbadge-close-btn')) return

    const closeButton = document.createElement('button')
    closeButton.innerHTML = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_555_24)">
<path d="M18.75 5.25L5.25 18.75" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M18.75 18.75L5.25 5.25" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<defs>
<clipPath id="clip0_555_24">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`
    closeButton.classList.add('trustbadge-close-btn')

    Object.assign(closeButton.style, {
      position: 'absolute',
      top: '5px',
      left: '1px',
      background: 'white',
      color: 'black',
      border: 'none',
      borderRadius: '50%',
      width: '20px',
      height: '20px',
      fontSize: '16px',
      cursor: 'pointer',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: '9999',
    })

    closeButton.addEventListener('click', function () {
      const script = document.querySelector('script[src*="trustedshops"]')
      script?.remove()

      const widget = document.getElementById('trustbadge-container-98e3dadd90eb493088abdc5597a70810')
      widget?.remove()

      if (window.trustbadge) {
        delete window.trustbadge
      }

      if (window._tsConfig) {
        window._tsConfig.disableTrustbadge = 'true'
      }
    })

    if (widget) {
      widget.style.position = 'relative'
      widget.appendChild(closeButton)
    }

    const widgetContainer = document.getElementById('minimized-trustbadge-98e3dadd90eb493088abdc5597a70810')
    const path = router.currentRoute.value.path

    if (widgetContainer) {
      if (path.includes('/checkout')) {
        widgetContainer.style.display = 'none'
      } else {
        widgetContainer.style.display = 'block'
      }
    }
  } catch (error) {
    console.warn('Failed to find widget for close button:')
  }
}
